import UIManager from "../Shared/UIManager";
import Utils from "../Shared/Utils";
import Constant from "../Shared/Constant";
import { Global } from "../Shared/Global";
import HallUI from "./HallUI";
import AddressManager from "../Shared/AddressManager";
const { ccclass, property } = cc._decorator;

@ccclass
export default class CheckHotUpdate extends cc.Component {
    @property({ type: cc.Asset })
    manifestUrl: cc.Asset = null

    private _am = null
    private _foundNewVersion = false

    onLoad() {
        cc.director.on(Global.UserEvent.EnterHall, this.onEnterHall, this)
        cc.game.on(cc.game.EVENT_SHOW, this.onAppShow, this)
    }

    onDestroy() {
        cc.director.off(Global.UserEvent.EnterHall, this.onEnterHall, this)
        cc.game.off(cc.game.EVENT_SHOW, this.onAppShow, this)
    }

    onEnterHall() {
        this.checkUpdate()
    }

    onAppShow() {
        let hallUI = cc.find("Canvas/gameNode") && cc.find("Canvas/gameNode").getComponent(HallUI)
        hallUI && hallUI.node.active && !hallUI.isExistChildUI() && this.checkUpdate()
    }

    checkCb(event) {
        cc.log('CheckHotUpdate: Code: ' + event.getEventCode())

        switch (event.getEventCode()) {
            case jsb.EventAssetsManager.ERROR_NO_LOCAL_MANIFEST:
                cc.log("===CheckHotUpdate: 没有找到本地的version.manifest文件")
                break
            case jsb.EventAssetsManager.ERROR_DOWNLOAD_MANIFEST:
            case jsb.EventAssetsManager.ERROR_PARSE_MANIFEST:
                cc.log("CheckHotUpdate: 下载version.manifest文件失败")
                break
            case jsb.EventAssetsManager.ALREADY_UP_TO_DATE:
                cc.log("CheckHotUpdate: 已经是最新版本")
                break
            case jsb.EventAssetsManager.NEW_VERSION_FOUND:
                cc.log('====CheckHotUpdate: 发现新版本')
                this._foundNewVersion = true
                // 重启游戏
                cc.sys.localStorage.removeItem("HotUpdateFinished")
                Utils.restartGame()
                break
            default:
                break
        }
    }

    private async checkUpdate() {
        if (!cc.sys.isMobile || this._foundNewVersion) return
        this._am = new jsb.AssetsManager(this.manifestUrl.nativeUrl, Constant.HotUpdateStoragePath, Utils.versionCompare)
        this._am.setEventCallback(this.checkCb.bind(this))
        // 设置热更域名
        let domain = await this.getHotUpdateDomain()
        let isDomainConnected = domain ? await this.checkDomainConnect(domain) : false
        if (isDomainConnected) {
            this._am.setHostUrl(domain)
            cc.log("CheckHotUpdate: 新的热更域名是：", domain)
        }
        this._am.checkUpdate()
    }

    private getHotUpdateDomain(): Promise<string> {
        return new Promise(resolve => {
            let domain = ""

            AddressManager.serverAddressArr.forEach(address => {
                let xhr = new XMLHttpRequest()
                xhr.responseType = 'json'

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        domain = xhr.response.data.value0 || ""
                    }
                    resolve(domain)
                }.bind(this)

                xhr.open("GET", address + "/imsbase/api/conf/getValue?type=hotUpdate", true)
                xhr.send()
            });

            // 2秒没有回调则使用默认地址
            this.scheduleOnce(function () {
                resolve(domain)
            }, 2)
        })
    }

    private checkDomainConnect(domain): Promise<boolean> {
        return new Promise(resolve => {
            let xhr = new XMLHttpRequest()

            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            }.bind(this)

            xhr.onerror = function () {
                resolve(false)
            }

            xhr.open("GET", domain, true)
            xhr.send()

            // 2秒没有回调false
            this.scheduleOnce(function () {
                resolve(false)
            }, 2)
        })
    }
}
